import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class TrainingService {

  constructor(private _http: HttpClient
    , private _environmentService: EnvironmentService
  ) { }

  getTrainers(): Observable<Object> {
    return this._http.get(this._environmentService.getFacilityConfig().facilityUrl + 'api/v1/Public/Trainers');
  }
}
